<template>
    <div class="container-fluid p-companies-show">
        <div class="mb-3">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="card">
                        <div class="card-header">法人詳細</div>
                        <div class="card-body pt-2">
                            <div class="vc-section">
                                <h5 class="vc-head-detail">基本情報</h5>
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class="vc-detail">
                                            <div class="vc-detail__title">法人番号</div>
                                            <div class="vc-detail__value">{{ `#${company.id}` }}</div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="vc-detail">
                                            <div class="vc-detail__title">法人名</div>
                                            <div class="vc-detail__value">
                                                <span v-if="company.name === null || company.name === ''" class="text-muted">-</span>
                                                <span v-else>{{ company.name }}</span><!--
                                             --><span v-if="company.name_kana !== null" class="small text-muted">（{{ company.name_kana }}）</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class="vc-detail">
                                            <div class="vc-detail__title">代表者名</div>
                                            <div class="vc-detail__value">
                                                <span v-if="company.representative === null || company.representative === ''" class="text-muted">-</span>
                                                <span v-else>{{ company.representative }}</span><!--
                                             --><span v-if="company.representative_kana !== null" class="small text-muted">（{{ company.representative_kana }}）</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="vc-detail">
                                            <div class="vc-detail__title">担当者</div>
                                            <div class="vc-detail__value">
                                                <template v-if="company.authorizer">
                                                    <a
                                                        href="#"
                                                        @click="showModalAdminUserProfile(company.authorizer.id)">
                                                        {{ `#${company.authorizer.id} ${company.authorizer.full_name}` }}
                                                    </a>
                                                </template>
                                                <template v-else>
                                                    <span class="text-muted">未設定</span>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class="vc-detail">
                                            <div class="vc-detail__title">住所</div>
                                            <div class="vc-detail__value">
                                                <span v-if="company.address === null || company.address === ''" class="text-muted">-</span>
                                                <span v-else>{{ company.address }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="vc-detail">
                                            <div class="vc-detail__title">電話番号</div>
                                            <div class="vc-detail__value">
                                                <span v-if="company.tel === null || company.tel === ''" class="text-muted">-</span>
                                                <span v-else>{{ company.tel }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class="vc-detail">
                                            <div class="vc-detail__title">会員数</div>
                                            <div class="vc-detail__value">{{ company.user_count.toString() }}</div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="vc-detail">
                                            <div class="vc-detail__title">ステータス</div>
                                            <div
                                                class="vc-detail__value"
                                                :class="{ 'text-danger font-weight-bold' : company.flg_paused }">
                                                {{ company.flg_paused ? '利用停止中' : '利用中' }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class="vc-detail">
                                            <div class="vc-detail__title">メモ</div>
                                            <div class="vc-detail__value" style="white-space: pre-wrap;">
                                                <div v-if="company.memo === null || company.memo === ''" class="text-muted">-</div>
                                                <div v-else>{{ company.memo }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="vc-detail">
                                            <div class="vc-detail__title">管理用タグ</div>
                                            <div class="vc-detail__value d-flex" style="white-space: pre-wrap;">
                                                <div v-if="company.group_management_tags.length < 1" class="text-muted">-</div>
                                                <div
                                                    v-for="tag in company.group_management_tags"
                                                    class="d-flex align-baseline">
                                                    <div class="groupManagementTag d-flex justify-content-center align-items-center">{{ tag.name }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class="vc-detail">
                                            <div class="vc-detail__title">担当者メモ</div>
                                            <div class="vc-detail__value" style="white-space: pre-wrap;">
                                                <div v-if="company.authorizer_memo === null || company.authorizer_memo === ''" class="text-muted">-</div>
                                                <div v-else>{{ company.authorizer_memo }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="vc-detail">
                                            <div class="vc-detail__title">担当者タグ</div>
                                            <div class="vc-detail__value d-flex" style="white-space: pre-wrap;">
                                                <div v-if="filteredGroupAuthorizerTags.length < 1" class="text-muted">-</div>
                                                <div
                                                    v-for="tag in filteredGroupAuthorizerTags"
                                                    class="d-flex align-baseline">
                                                    <div class="groupAuthorizerTag d-flex justify-content-center align-items-center">{{ tag.name }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="vc-section">
                                <h5 class="vc-head-detail">担当者設定</h5>
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class="vc-detail">
                                            <div class="vc-detail__title">{{ $locale.consultation_host }}一覧タブ</div>
                                            <div
                                                class="vc-detail__value">
                                                {{ company.is_tab_consultation ? '表示する' : '表示しない' }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="vc-detail">
                                            <div class="vc-detail__title">{{ $locale.consultation_host }}詳細</div>
                                            <div
                                                class="vc-detail__value">
                                                {{ company.is_viewable_authorizer ? '表示する' : '表示しない' }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="vc-section">
                                <h5 class="vc-head-detail">サービス設定</h5>
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class="vc-detail">
                                            <div class="vc-detail__title">利用サービスモデル</div>
                                            <div class="vc-detail__value">
                                                <div v-if="company.plans.length < 1" class="text-muted">-</div>
                                                <span v-for="(plan, index) in company.plans">
                                                    <span>{{ plan.name }}</span><!--
                                                 --><span v-if="company.plans.length !== index + 1" class="text-muted">、</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6">
                                        <div class="vc-detail">
                                            <div class="vc-detail__title">健康管理パッケージ</div>
                                            <div
                                                class="vc-detail__value">
                                                {{ company.is_health_package ? '利用する' : '利用しない' }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class="vc-detail">
                                            <div class="vc-detail__title">メンタルチェック</div>
                                            <div
                                                class="vc-detail__value">
                                                {{ company.is_health_survey ? '利用する' : '利用しない' }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="vc-detail">
                                            <div class="vc-detail__title">メンタルチェックの回答時間（日本時間）</div>
                                            <div
                                                v-if="company.is_health_survey"
                                                class="vc-detail__value">
                                                {{ `${company.health_survey_start_time.substring(0, 5)} 〜 ${company.health_survey_end_time.substring(0, 5)}` }}
                                            </div>
                                            <div
                                                v-else
                                                class="vc-detail__value text-muted">
                                                -
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-end mt-3">
                                <b-button
                                    variant="yokumiru-ash"
                                    class="ml-2 mr-2 text-muted"
                                    :href="previousUrl !== null ? previousUrl : '/admin/companies'">
                                    戻る
                                </b-button>
                                <b-button
                                    variant="yokumiru-blue"
                                    class="ml-2 mr-2"
                                    @click="showModalAdminCompanyEdit">
                                    編集
                                </b-button>
                                <b-button
                                    variant="danger"
                                    class="ml-2 mr-2"
                                    @click="showModalAdminCompanyDelete">
                                    削除
                                </b-button>
                                <b-button
                                    v-if="!company.flg_paused"
                                    variant="outline-danger"
                                    class="ml-2 mr-2"
                                    @click="showModalAdminCompanyPause">
                                    利用停止
                                </b-button>
                                <b-button
                                    v-if="company.flg_paused"
                                    variant="yokumiru-outline-blue"
                                    class="ml-2 mr-2"
                                    @click="showModalAdminCompanyResume">
                                    利用再開
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-card no-body>
            <b-tabs card>
                <b-tab :title="`${$locale.patient}一覧`">
                    <b-container fluid>
                        <admin-group-users
                            :group="company"
                            :user-categories="userCategories">
                        </admin-group-users>
                    </b-container>
                </b-tab>
                <b-tab :title="`${$locale.consultation_host}一覧`">
                    <b-container fluid>
                        <admin-group-consultations
                            :group="company"
                            :parent-group="parentGroup"
                            :medical-courses="medicalCourses">
                        </admin-group-consultations>
                    </b-container>
                </b-tab>
                <b-tab title="請求一覧">
                    <b-container fluid>
                        <admin-group-invoices
                            :group="company">
                        </admin-group-invoices>
                    </b-container>
                </b-tab>
                <b-tab title="メンタルチェック回答一覧">
                    <b-container fluid>
                        <admin-group-health-surveys
                            :group="company">
                        </admin-group-health-surveys>
                    </b-container>
                </b-tab>
                <b-tab title="ヘルスアンサー月次レポート一覧">
                    <b-container fluid>
                        <admin-group-health-survey-reports
                            :group="company">
                        </admin-group-health-survey-reports>
                    </b-container>
                </b-tab>
            </b-tabs>
        </b-card>

        <admin-edit-group-modal/>
        <admin-delete-group-modal/>
        <admin-pause-group-modal/>
        <admin-resume-group-modal/>
        <doctor-menu-modal user-type="admin"/>
        <admin-user-profile-modal timezone="Asia/Tokyo"/>
        <consultation-cancel-info-modal/>
        <admin-add-health-survey-group-detail-modal/>
        <admin-edit-health-survey-group-detail-modal/>
        <admin-doctor-profile-modal/>
    </div>
</template>

<script>
    import constants from '../../../constants'
    import YokumiruHelper from '../../../YokumiruHelper'

    export default {
        name: 'AdminCompany',

        props: {
            dataCompany: {
                type: Object,
                required: true,
            },
            parentGroup: {
                type: Object,
                default: null,
            },
            userCategories: {
                type: Array,
                required: true,
            },
            medicalCourses: {
                type: Array,
                required: true,
            },
            previousUrl: {
                type: String|null,
                required: true,
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                company: null,
            }
        },

        computed: {
            /**
             * 管理用タグ（担当者用）
             * @return {T[]}
             */
            filteredGroupAuthorizerTags: function () {
                if (!this.parentGroup || !this.company || this.company.group_authorizer_tags.length < 1) {
                    return []
                }
                return this.company.group_authorizer_tags.filter((tag) => tag.authorizer_id === this.parentGroup.authorizer_id)
            },
        },

        created: function () {
            this.company = {...this.dataCompany}
            bus.$on('fetch-group', this.fetchCompany)
        },

        beforeDestroy: function () {
            bus.$off('fetch-group')
        },

        methods: {
            /**
             * 法人詳細取得
             */
            fetchCompany: function () {
                const endpoint = constants.admin.groups.endpoint.base

                axios.get(`${endpoint}/${this.company.id}`)
                    .then(({data}) => {
                        this.company = data.data
                    })
            },

            /**
             * グループ編集モーダル表示
             */
            showModalAdminCompanyEdit: function () {
                bus.$emit('open-modal-admin-edit-group', this.company)
            },

            /**
             * グループ削除モーダル表示
             */
            showModalAdminCompanyDelete: function () {
                bus.$emit('open-modal-admin-delete-group', this.company)
            },

            /**
             * グループ利用停止モーダル表示
             */
            showModalAdminCompanyPause: function () {
                bus.$emit('open-modal-admin-pause-group', this.company)
            },

            /**
             * グループ利用再開モーダル表示
             */
            showModalAdminCompanyResume: function () {
                bus.$emit('open-modal-admin-resume-group', this.company)
            },

            /**
             * 会員詳細モーダル表示
             *
             * @param {number} userId
             */
            showModalAdminUserProfile: function (userId) {
                bus.$emit('open-modal-admin-user-profile', userId)
            },
        },
    }
</script>

<style lang="scss" scoped>
.groupManagementTag {
    padding: 3px 5px;
    margin-right: 5px;
    color: #3461b4;
    font-size: .85em;
    background-color: #f2f4f8;
    border: 1px solid #dce4ed;
    border-radius: 2px;
}

.groupAuthorizerTag {
    padding: 3px 5px;
    margin-right: 5px;
    color: #5834b4;
    font-size: .85em;
    background-color: #f4f2f8;
    border: 1px solid #e2dced;
    border-radius: 2px;
}

.vc-section {
    margin-bottom: 10px;

    &:last-child {
        margin-bottom: 0;
    }
}

.vc-head-detail {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 0;
    padding: 10px 0 0;
}

.vc-detail {
    margin: 8px 0;

    .vc-detail__title {
        color: #6c757d;
    }

    .vc-detail__value {
        padding: 4px 0 3px;
        border-bottom: 1px solid #dfdfdf;
    }
}
</style>
